/**
 * <s-footer-accordion> — footer link columns.
 * Columns render as open <details> so links are always present without JavaScript
 * (desktop, editor, preview). On small screens this element collapses them into an
 * accordion; from the md breakpoint up they are kept open and summaries stop toggling.
 */
class SFooterAccordion extends HTMLElement {
  #ac;
  #query;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.#query = window.matchMedia('(min-width: 768px)');
    this.#sync();
    this.#query.addEventListener('change', () => this.#sync(), opts);
    this.addEventListener('click', (event) => {
      const summary = event.target.closest('summary');
      if (summary && this.contains(summary) && this.#query.matches) event.preventDefault();
    }, opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    const desktop = this.#query.matches;
    this.querySelectorAll('details').forEach((details) => {
      details.open = desktop;
    });
  }
}

if (!customElements.get('s-footer-accordion')) {
  customElements.define('s-footer-accordion', SFooterAccordion);
}
